import { AfterViewInit, Component, Injector, OnInit, ViewChild } from '@angular/core';
import { RuleFaviconExistedParam } from 'tnx-admin-service/rule/services';
import { EnumRuleType } from 'tnx-admin-service/rule/services';
import { CheckResult } from 'tnx-admin-service/rule/services';
import { BasicRule } from 'tnx-admin-service/rule/services';
import { RuleService } from 'tnx-admin-service/rule/services';
import { RuleBuilderService } from 'tnx-admin-service/rule/services';
import { ColumnSchemaBase, ComponentContextService, CrudListComponent, DataListBase, GridInfo, ModelSchema, EnvironmentService, Operator } from 'tnx-shared';
@Component({
    selector: 'rule',
    templateUrl: './rule.component.html',
    styleUrls: ['./rule.component.scss'],
    providers: [ComponentContextService, RuleBuilderService],
})
export class RuleComponent extends DataListBase implements OnInit, AfterViewInit {
    searchSchema: any = {};
    searchData: any = {};
    ruleChecking = false;
    env: any;
    constructor(
        protected _injector: Injector,
        protected _ruleService: RuleService,
        private _ruleBuilderService: RuleBuilderService,
    ) {
        super(_injector);
        this.env = this._environmentService.environment;
    }

    ngOnInit() {
        this.setting.pageSetting.pageSize = 50;
        this.setting.baseService = this._ruleService;
        this.setting.modelSchemas = [
            new ModelSchema({ field: 'code', name: 'Mã rule', fullName: 'Mã rule', description: 'Mã rule' }),
            new ModelSchema({ field: 'author', name: 'Người tạo rule', fullName: 'Người tạo rule', description: 'Người tạo rule' }),
            new ModelSchema({ field: 'title', name: 'Tên rule', fullName: 'Tên rule', description: 'Tên rule' }),
            new ModelSchema({ field: 'description', name: 'Mô tả chi tiết hơn rule', fullName: 'Mô tả chi tiết hơn rule', description: 'Mô tả chi tiết hơn rule' }),
            new ModelSchema({ field: 'ruleType', name: 'Loại rule (sqlschema,etcd,environment,sqldata....)', fullName: 'Loại rule (sqlschema,etcd,environment,sqldata....)', description: 'Loại rule (sqlschema,etcd,environment,sqldata....)' }),
            new ModelSchema({ field: 'ruleParams', name: 'Tham số để có thể check rule', fullName: 'Tham số để có thể check rule', description: 'Tham số để có thể check rule' }),
            new ModelSchema({ field: 'rulePassed', dataType: 'boolean', name: 'Rule đang thỏa mãn hay không thỏa mãn', fullName: 'Rule đang thỏa mãn hay không thỏa mãn', description: 'Rule đang thỏa mãn hay không thỏa mãn' }),
            new ModelSchema({ field: 'passedAt', dataType: 'date', name: 'Thời gian rule chuyển sang trạng thái thỏa mãn', fullName: 'Thời gian rule chuyển sang trạng thái thỏa mãn', description: 'Thời gian rule chuyển sang trạng thái thỏa mãn' }),
            new ModelSchema({ field: 'lastCheckedAt', dataType: 'date', name: 'Lần kiểm tra cuối', fullName: 'Lần kiểm tra cuối', description: 'Lần kiểm tra cuối' }),
            new ModelSchema({ field: 'lastFailedAt', dataType: 'date', name: 'Thời điểm gần nhất rule chuyển sang không thỏa mãn', fullName: 'Thời điểm gần nhất rule chuyển sang không thỏa mãn', description: 'Thời điểm gần nhất rule chuyển sang không thỏa mãn' }),
            new ModelSchema({ field: 'nextCheckedAt', dataType: 'date', name: 'Lần kiểm tra rule tiếp theo', fullName: 'Lần kiểm tra rule tiếp theo', description: 'Lần kiểm tra rule tiếp theo' }),
            new ModelSchema({ field: 'intervalCheckInMinutes', dataType: 'int', name: 'Thời gian giữa mỗi lần kiểm tra rule', fullName: 'Thời gian giữa mỗi lần kiểm tra rule', description: 'Thời gian giữa mỗi lần kiểm tra rule' }),
            new ModelSchema({ field: 'currentStateCode', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'executionTime', dataType: 'int', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'exception', name: 'Lỗi khi check rule (nếu có)', fullName: 'Lỗi khi check rule (nếu có)', description: 'Lỗi khi check rule (nếu có)' }),
            new ModelSchema({ field: 'isApi', name: 'Là Api rule', fullName: 'Là rule kiểm tra phía api', description: 'Là rule kiểm tra phía api (phân biệt với rule kiểm tra phía angular client)' })
        ];

        this.setting.cols = [
            new ColumnSchemaBase({ field: 'ruleTypeString', label: 'Loại', width: '15em' }),
            new ColumnSchemaBase({ field: 'ruleParams', dataType: 'ruleParams' }),
            new ColumnSchemaBase({ field: 'exception', width: '35em' }),
            new ColumnSchemaBase({ field: 'rulePassed', width: '10em' }),
            new ColumnSchemaBase({ field: 'isApi', dataType: 'boolean', width: '10em' }),
        ];

        this.setting.popupSize.width = 950;
        this.setting.popupSize.height = 650;
        this.addBuildinRule();
        super.ngOnInit();
    }

    addBuildinRule() {
        this._ruleBuilderService
            .addRule(EnumRuleType.ClientFaviconExisted, new RuleFaviconExistedParam({

            }), new BasicRule({
                description: 'Favicon được khai báo trong file <environment>.json (ví dụ môi trường prod là prod.json), tại key env.appMetadata.main.favicon'
            }))
            .commit();
    }

    async afterGetData() {
        this.model.dataSource.forEach(x => {
            x.ruleTypeString = this.getRoleTypeString(x.ruleType);
            if (x.exception !== null && x.exception !== '') {
                x.exception = x.exception.toString().substring(0, 300) + ' ...';
            }
        });
    }

    getRoleTypeString(roleType) {
        switch (roleType) {
            // api side
            // SQL Structure
            case 'SqlDatabaseNameRequired': return 'Database tồn tại';
            case 'SqlTableNameRequired': return 'Bảng tồn tại';
            case 'SqlColumnNameRequired': return 'Cột tồn tại';
            // SQL Data
            case 'RecordExistedByCode': return 'Tồn tại 1 bản ghi theo code';
            case 'RecordExistedByInstanceId': return 'Tồn tại 1 bản ghi theo instanceid';
            case 'RecordExistedByServiceCodeEntityEntityKey': return 'Tồn tại 1 bản ghi theo ServiceRequestModel';
            case 'RecordExistedById': return 'Tồn tại 1 bản ghi theo id';
            case 'RecordExistByFieldValue': return 'Tồn tại 1 bản ghi theo giá trị của 1 cột';
            // Etcd Config
            case 'ConfigKeyNameRequired': return '1 key tồn tại (có giá trị)';
            case 'ConfigKeyEqualValue': return '1 key có giá trị đúng bằng giá trị mong muốn';
            case 'ConfigKeyNotEqualValue': return '1 key có giá trị bất kỳ nhưng không bằng giá trị mong muốn';
            // Api
            case 'ApiLive': return '1 API có response trả về';
            case 'ApiReturnCorrectValue': return '1 api có response trả về như mong muốn';
            // Redis
            case 'RedisLive': return 'Redis đang hoạt động';
            // RabbitMQ
            case 'RabbitMQLive': return 'Rabbitmq đang hoạt động';
            case 'RabbitMQHasVirtualHost': return 'Rabbitmq tồn tại virtual host với tên như mong muốn';
            case 'RabbitMQHasExchange': return 'Rabbitmq tồn tại exchange với tên và một số đặc tính như mong muốn';
            // end api side

            // client side
            case 'ClientFaviconExisted': return 'Favicon tồn tại';
            // end client side
            default: return '';
        }
    }

    manualCheck() {
        this._notifierService.showSuccess('Đang kiểm tra (API)');
        this.ruleChecking = true;
        this._ruleService.manualCheck(<any>{}).then(rs => {
            this._notifierService.showSuccess('Kiểm tra hoàn thành (API)');
            this._triggerProcessData();
            this.ruleChecking = false;
        }).catch(err => {
            this.ruleChecking = false;
            this._notifierService.showWarning('Không thể kiểm tra vào thời điểm này (API)');
        });
    }

    manualCheckClient() {
        this._notifierService.showSuccess('Đang kiểm tra (Client)');
        this.ruleChecking = true;
        this._ruleService.getClientRule(<any>{}).then(rs => {
            this._notifierService.showSuccess('Lấy thông tin thành công, đang kiểm tra (Client)');
            this.doCheck(rs.data).then(rss => {
                this._notifierService.showSuccess('Kiểm tra hoàn thành (Client)');
                this.ruleChecking = false;
                this._triggerProcessData();
            }).catch(err => {
                this._notifierService.showSuccess('Không thể kiểm tra vào thời điểm này (Client)');
                console.error(err);
                this.ruleChecking = false;
            })
        }).catch(err => {
            this.ruleChecking = false;
            console.error(err);
            this._notifierService.showWarning('Không thể kiểm tra vào thời điểm này (Client)');
        });
    }

    async doCheck(rules: any[]) {
        let rs: CheckResult = null;
        for (const rule of rules) {
            switch (rule.ruleType) {
                case EnumRuleType[EnumRuleType.ClientFaviconExisted]:
                    rs = await this.doCheckClientFaviconExisted(rule);
                    break;
            }

            rule.rulePassed = rs.ruleRassed;
            rule.exception = rs.exception;
            rule.executionTime = rs.executionTime;

            try {
                const rs = await this._ruleService.updateClientCheck(rule);
                if (rs.success) {
                    this._notifierService.showSuccess(`Cập nhật trạng thái ${rule.rulePassed} của rule ${rule.code} thành công`);
                } else {
                    this._notifierService.showWarning(`Không thể cập nhật trạng thái ${rule.rulePassed} của rule ${rule.code}`);
                }
            } catch (err) {
                console.error(err);
                this._notifierService.showWarning(`Không thể cập nhật trạng thái ${rule.rulePassed} của rule ${rule.code}`);
            }
        }
        return true;
    }

    async doCheckClientFaviconExisted(rule: any): Promise<CheckResult> {
        return new Promise((resolve) => {
            if (!this.env.appMetadata.main.favicon) {
                resolve(CheckResult.withNotPassed('Favicon chưa được thiết lập trong environment.appMetadata.main.favicon'));
            } else {
                this.imageExists(this.env.appMetadata.main.favicon, (rs) => {
                    if (rs) {
                        resolve(CheckResult.withPassed());
                    } else {
                        resolve(CheckResult.withNotPassed('Favicon không tồn tại'));
                    }
                });
            }
        });
    }

    // The "callback" argument is called with either true or false
    // depending on whether the image at "url" exists or not.
    private imageExists(url, callback) {
        const img = new Image();
        img.onload = () => { callback(true); };
        img.onerror = () => { callback(false); };
        img.src = url;
    }

    async modifyGridInfo(gridInfo: GridInfo) {
        if (gridInfo.filters.length == 0) {
            gridInfo.filters = [{ filters: [], field: 'rulePassed', operator: Operator.equal, value: 'false' }];
        }
        gridInfo.sorts.splice(0, 0,
            { field: 'created', dir: -1 }
        );
    }
}

